import { render, staticRenderFns } from "./ExtrusionDayReport.vue?vue&type=template&id=c2ed60fa&scoped=true"
import script from "./ExtrusionDayReport.vue?vue&type=script&lang=js"
export * from "./ExtrusionDayReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ed60fa",
  null
  
)

export default component.exports